import { palette } from './palette';
import background from 'assets/images/faq-banner-img.webp';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.rodeo-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.text.alternate,
      minHeight: '680px',

      '@media screen and (max-width: 900px)': {
        minHeight: '100%',
      },

      '& .hero-background': {
        objectFit: 'cover',

        '@media screen and (max-width: 900px)': {
          position: 'absolute',
        },
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper, & .section-header__cta-container':
        {
          display: 'flex',
          justifyContent: 'center',
          '& .home-hero-title': {
            fontSize: 64,
            fontWeight: 600,
            textAlign: 'center',
          },
          '& .home-hero-subtitle': {
            fontSize: 18,
            maxWidth: 650,
            textAlign: 'center',
          },
          '@media screen and (max-width: 900px)': {
            '& .home-hero-title': {
              fontSize: 26,
              textAlign: 'center',
            },
            '& .home-hero-subtitle': {
              fontSize: 13,
              textAlign: 'center',
            },
          },
        },
      '& .section-header__cta-item-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        '@media screen and (min-width: 900px)': {
          flexDirection: 'row',
          gap: '10px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '500px',

        '& .MuiSelect-outlined': {
          background: palette.primary.main,
          color: palette.text.highlight,
          borderRadius: '10px',
        },
      },

      '& .login-button': {
        padding: '12px 42px',
        marginLeft: '0px !important',
        color: palette.secondary.main,
        border: `1px solid ${palette.secondary.main}`,
        background: palette.text.highlight,
        borderColor: `${palette.secondary.main} !important`,
      },

      '& .home-hero-title': {
        maxWidth: 900,

        '@media(min-width: 900px)': {
          lineHeight: 1.375,
        },
      },
      '& .home-hero-title, & .home-hero-subtitle': {
        fontSize: '2.0243rem',
        color: palette.text.highlight,
      },
    },

    /* Benefits - Styles */
    '& .definition-variant-2': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',

      '@media(max-width: 900px)': {
        paddingTop: 0,
      },

      '& .benefits-wrapper': {
        '& .section-header__title': {
          paddingBottom: 64,

          '@media(max-width: 900px)': {
            paddingBottom: 24,
          },
        },
        '& .definition-service-title': {
          fontSize: 24,
          fontWeight: 600,
        },
        '& .definition-service-description': {
          fontSize: 16,
          fontWeight: 400,
          paddingBottom: 40,
          color: palette.text.light,

          '@media(min-width: 900px)': {
            maxWidth: 350,
          },
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingLeft: '74px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: `url('./images/home-images/pricing-pattern.webp')`,
      backgroundSize: 'cover',
      '& .subscription-bg': {
        position: 'unset',
        height: 576,
        background: `url('./images/home-images/subscription-bg.webp') no-repeat center`,
        backgroundSize: 'cover',
      },
      '& .section-header__title-wrapper': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
      },
      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '& .section-header__subtitle': {
          color: palette.text.primary,
          maxWidth: '550px',
        },
      },
      '& .subscription-tabs-label': {
        color: palette.text.primary,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
        },
        '& .summary-text, .summary-subtext': {
          color: palette.text.primary,
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.primary.main,
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .step-counter': {
        backgroundColor: palette.primary.main,
        fontSize: 16,
      },
      '& .step-content': {
        maxWidth: 400,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        borderColor: `${palette.background.tableSubhead} !important`,

        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        backgroundColor: palette.alternate.light,

        '& .footer-bar-text': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        padding: '0px 0px !important',
        background: palette.background.footer,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .faq-hero-section, & .checkout-hero-section':
      {
        '& .hero-header-title, & .hero-header-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
        background: palette.secondary.main,
        '& .hero-link-button':{
          background: palette.text.highlight,
          color: palette.secondary.main,
        },
        '& .hero-home-button':{
          background: palette.secondary.main,
          color: palette.text.highlight,
          borderColor: `${palette.text.highlight} !important`,
        },
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        background: `url('./images/home-images/pattern.webp') no-repeat center`,
        backgroundSize: 'cover',
        backgroundColor: palette.background.primary,
      },
      '& .section-header__title, .section-header__subtitle': {
        color: `${palette.text.primary} !important`,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '& .section-header__title, & .section-header__subtitle, & .patient-label':
        {
          color: palette.text.highlight,
        },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .custom-avatar': {
        display: 'none',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.background.arrow,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100,
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.light,
      },
      '& .faq-link': {
        fontWeight: 500,
      },
    },
    '& .faq-contact-wrapper': {
      backgroundColor: palette.background.primary,
      background: `url('./images/home-images/pattern.webp') no-repeat center`,
      backgroundSize: 'cover',
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-title, & .contact-card-subtitle, & .provider-contact-details, & .provider-contact-link':
          {
            color: palette.text.primary,
          },
      },
    },

    '& .footer-wrapper': {
      background: palette.text.primary,
      color: palette.text.highlight,
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          border: `1px solid ${palette.primary.main}`,
          color: palette.text.primary,
          background: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
        '& .price-value': {
          color: palette.text.primary,
          fontWeight: 'bold',
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .section-header__title, & .section-header__subtitle': {
          color: palette.text.highlight,
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /*Dashboard - styles */
    '& .benefits-widget': {
      '& .MuiTableCell-head': {
        color: `${palette.text.highlight} !important`,
      },
    },
  },
};
